<div id="containerCompleto">
  <div id="titulo">
    <h2>Seleccione una póliza</h2>
    <h2 id="btnCerrar" mat-flat-button (click)="onClose()">X</h2>
  </div>

  <div id="tablaContainer">
    <table mat-table [dataSource]="data.polizas" class="mat-elevation-z8">

      <ng-container matColumnDef="idPoliza">
        <th mat-header-cell *matHeaderCellDef>Póliza</th>
        <td mat-cell *matCellDef="let element">{{element.poliza.idPoliza}}</td>
      </ng-container>

      <ng-container matColumnDef="producto">
        <th mat-header-cell *matHeaderCellDef>Producto</th>
        <td mat-cell *matCellDef="let element">{{element.poliza.producto.descripcion}}</td>
      </ng-container>

      <ng-container matColumnDef="titular">
        <th mat-header-cell *matHeaderCellDef>Titular</th>
        <td mat-cell *matCellDef="let element">{{element.poliza.tomador?.nombre}}</td>
      </ng-container>

      <ng-container matColumnDef="matricula">
        <th mat-header-cell *matHeaderCellDef>Matrícula</th>
        <td mat-cell *matCellDef="let element">{{element.vehiculo?.matricula}}</td>
      </ng-container>

      <ng-container matColumnDef="marca">
        <th mat-header-cell *matHeaderCellDef>Marca</th>
        <td mat-cell *matCellDef="let element">{{element.vehiculo?.marca}}</td>
      </ng-container>

      <ng-container matColumnDef="modelo">
        <th mat-header-cell *matHeaderCellDef>Modelo</th>
        <td mat-cell *matCellDef="let element">{{element.vehiculo?.modelo}}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="['idPoliza','producto','titular','matricula','marca','modelo']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['idPoliza','producto','titular','matricula','marca','modelo'];"
          (dblclick)="dialogRef.close(row)">
      </tr>
    </table>
  </div>
</div>
